import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";

export default class UserCirclesIndexRoute extends DiscourseRoute {
  @service router;

  beforeModel() {
    this.router.transitionTo("user.circles.type", "member");
  }
}
